export default "__VITE_ASSET__Cv2cpSz5__"